import { render, staticRenderFns } from "./vendor-project-list.vue?vue&type=template&id=5859ebd2&scoped=true&"
import script from "./vendor-project-list.vue?vue&type=script&lang=js&"
export * from "./vendor-project-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5859ebd2",
  null
  
)

export default component.exports